module.exports = __webpack_public_path__ + "static/dotnet-2b5412b88685cb52da290eea565a99a3.svg";